var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-item",attrs:{"name":"game-preview-skeleton"}})
}
var staticRenderFns = []

export { render, staticRenderFns }